import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'transactionAmountClass' })
export class TransactionAmountClassPipe implements PipeTransform {
  public transform(value: number): string | string[] | Set<string> | { [klass: string]: boolean } {
    if (value <= 0 || value === Number.MAX_SAFE_INTEGER) {
      return 'tx-amount-debit';
    }
    return 'tx-amount-credit';
  }
}
